import { CloseButton, DialogBackdrop, DialogContent, DialogHeader, DialogPositioner, DialogRoot, DialogTitle, Portal } from "@chakra-ui/react"

export default function Dialog({ children, title, loading = false, onClose = () => {}, ...props }){
    return(
        <DialogRoot
            onInteractOutside={onClose}
            onEscapeKeyDown={onClose}
            closeOnInteractOutside={!loading}
            motionPreset="slide-in-top"
            {...props}
        >
            <Portal>
                <DialogBackdrop />
                <DialogPositioner>
                    <DialogContent position="relative"> {/* Garante a referência para o botão */}

                        <DialogHeader>
                            <DialogTitle children={title} />
                        </DialogHeader>

                        {/* Botão de fechar fora do Header e com posicionamento absoluto */}
                        <CloseButton
                            disabled={loading}
                            onClick={!loading ? onClose : null}
                            position="absolute"
                            top="2"
                            insetEnd="2"
                        />

                        { children }
                    </DialogContent>
                </DialogPositioner>
            </Portal>
        </DialogRoot>
    )
}